import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { register } from '../services/api';
import { useAuth } from '../services/AuthContext';
import TermsAcceptance from '../components/TermsAcceptance';

function VendorRegister() {
  const [form, setForm] = useState({ email: '', password: '', businessName: '', specialty: '', bio: '', city: '', state: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const { loginVendor } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    if (!form.email || !form.password || !form.businessName) { setError('Email, password, and business name are required'); return; }
    if (form.password.length < 8) { setError('Password must be 8+ characters'); return; }
    setShowTerms(true);
  };

  const handleAcceptTerms = async () => {
    setShowTerms(false);
    setLoading(true);
    try {
      const payload = { ...form };
      if (payload.city) {
        try {
          const q = encodeURIComponent(`${payload.city}, ${payload.state || ''}`);
          const res = await fetch(`https://nominatim.openstreetmap.org/search?q=${q}&format=json&limit=1`);
          const geo = await res.json();
          payload.location = { city: payload.city, state: payload.state, country: 'US' };
          if (geo.length > 0) { payload.location.lat = geo[0].lat; payload.location.lng = geo[0].lon; }
        } catch (e) {
          payload.location = { city: payload.city, state: payload.state, country: 'US' };
        }
      }
      delete payload.city;
      delete payload.state;
      const data = await register(payload);
      loginVendor(data.token, data.vendor);
      navigate('/vendor/dashboard');
    } catch (err) {
      setError(err.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page vendor-auth">
      <div className="auth-card">
        <span className="auth-badge">Vendor Portal</span>
        <h2>Vendor Registration</h2>
        <p className="auth-subtitle">Set up your booth on Timber Summit</p>
        {error && <div className="auth-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Business Name *"
            value={form.businessName}
            onChange={e => setForm({ ...form, businessName: e.target.value })}
            required
          />
          <input
            type="email"
            placeholder="Email *"
            value={form.email}
            onChange={e => setForm({ ...form, email: e.target.value })}
            required
          />
          <input
            type="password"
            placeholder="Password (8+ characters) *"
            value={form.password}
            onChange={e => setForm({ ...form, password: e.target.value })}
            required
            minLength={8}
          />
          <select
            value={form.specialty}
            onChange={e => setForm({ ...form, specialty: e.target.value })}
          >
            <option value="">Select Specialty</option>
            <option value="Fine Furniture">Fine Furniture</option>
            <option value="Rustic Decor">Rustic Decor</option>
            <option value="Small Goods">Small Goods</option>
            <option value="Reclaimed Art">Reclaimed Art</option>
            <option value="Joinery">Joinery</option>
            <option value="Woodturning">Woodturning</option>
            <option value="Carving">Carving</option>
            <option value="Other">Other</option>
          </select>
          <textarea
            placeholder="Short bio about your craft..."
            value={form.bio}
            onChange={e => setForm({ ...form, bio: e.target.value })}
            rows={3}
          />
          <div className="location-fields">
            <input type="text" placeholder="City *" value={form.city} onChange={e => setForm({ ...form, city: e.target.value })} required />
            <input type="text" placeholder="State" value={form.state} onChange={e => setForm({ ...form, state: e.target.value })} maxLength={2} />
          </div>
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Creating Account...' : 'Create Vendor Account'}
          </button>
        </form>
        <p className="auth-link">Already have an account? <Link to="/vendor/login">Sign in</Link></p>
      </div>
      {showTerms && <TermsAcceptance onAccept={handleAcceptTerms} onCancel={() => setShowTerms(false)} />}
    </div>
  );
}

export default VendorRegister;
